import React, { useState } from 'react';

import Alert from '@amzn/meridian/alert';
import Link from '@amzn/meridian/link';
import Text from '@amzn/meridian/text';
import { RTW_WIKI_URL } from 'src/config/ExternalLinks';

const WIKI_LINK_TEXT = 'Learn more on our RTW wiki.';

interface NewFeatureProps {
  label: string;
  text: React.ReactNode;
  link?: string;
  linkText?: string;
}
const NewFeatureBanner = ({ label, text, link = RTW_WIKI_URL, linkText = WIKI_LINK_TEXT }: NewFeatureProps) => {
  const cleanedLabel = label.replace(' ', '');
  const [isOpen, setIsOpen] = useState(!localStorage.getItem(cleanedLabel));

  const onClose = () => {
    localStorage.setItem(cleanedLabel, 'true');
    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <Alert onClose={onClose} type="theme">
      <Text type="h100">New Feature Available!</Text>
      {text}{' '}
      <Link href={link} target="_blank" rel="noopener noreferrer">
        {linkText}
      </Link>
    </Alert>
  );
};

export default NewFeatureBanner;
